import { graphql, useStaticQuery } from 'gatsby';

const useContacto = () => {

    const data = useStaticQuery(graphql`
        query {
            allDatoCmsContacto(filter: {}) {
                nodes {
                  telefono,
                  email,
                  address
                }
            }
        }
    `);

    return data.allDatoCmsContacto.nodes[0];
}
 
export default useContacto;